// ProgressiveLoader.tsx
import React from "react";
import { CheckCircle, XCircle, Loader2 } from "lucide-react";

type StageStatus = "pending" | "loading" | "success" | "error";

interface ProgressiveLoaderProps {
  stages: {
    label: string;
    status: StageStatus;
  }[];
}

export const ProgressiveLoader: React.FC<ProgressiveLoaderProps> = ({ stages }) => {
  const renderIcon = (status: StageStatus) => {
    switch (status) {
      case "success":
        return <CheckCircle className="text-green-500" />;
      case "error":
        return <XCircle className="text-red-500" />;
      case "loading":
        return <Loader2 className="animate-spin text-blue-500" />;
      default:
        return <span className="text-gray-400">⏳</span>;
    }
  };

  return (
 <div className="w-80 space-y-4 fixed bottom-4 right-4 z-40">
   {stages.slice().reverse().map((stage, i) => (
  <div
    key={i}
    className="flex row-reverse items-center justify-between bg-white p-4 rounded shadow"
  >
    <span>{stage.label}</span>
    <span>{renderIcon(stage.status)}</span>
  </div>
))}

    </div>
  );
};